export const LoginForminitialValues = {
  email: '',
  password: '',
};
